import React, { useState } from 'react';
import TypingEffect from './TypingEffect';

const TypingEffectSequence = ({ texts, speed, color, fontFamily, fontSize }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleComplete = () => {
        // Move to the next TypingEffect in the sequence
        if (currentIndex < texts.length - 1) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    return (
        <div>
            {texts.map((text, index) => (
                index === currentIndex && (
                    <TypingEffect
                        key={index}
                        text={text}
                        speed={speed}
                        color={color}
                        fontFamily={fontFamily}
                        fontSize={fontSize}
                        onComplete={handleComplete}
                    />
                )
            ))}
        </div>
    );
};

export default TypingEffectSequence;
